import urls, { getDevdocsUrl, getPlatformUrl } from "../../shared/config/urls";

interface MarkdownNode {
  type: string;
  url?: string;
  children?: MarkdownNode[];
}

/**
 * Remark plugin: points markdown links to the production Portal or docs at
 * the same site in the environment being built, so a preprod docs build links
 * to preprod. Runs at build time with no window, so the URLs come from the
 * build env, and the prerendered HTML and the client bundle agree.
 * Raw markdown exports (*.md, llms.txt) keep the source URLs. Only the href
 * changes; link text that spells out the production host stays as written.
 *
 * Under local `zudoku dev`, Zudoku forces NODE_ENV=development, so Portal links
 * point at http://localhost:8080 and only work while the Portal runs locally.
 * The nav and footer links behave the same way.
 */
export function remarkEnvironmentLinks() {
  const hosts = [
    { production: urls.platform.production, current: getPlatformUrl(null) },
    { production: urls.devdocs.production, current: getDevdocsUrl(null) },
  ];

  const rewrite = (url: string): string => {
    for (const { production, current } of hosts) {
      if (
        url === production ||
        (url.startsWith(production) && /^[/?#]/.test(url.slice(production.length)))
      ) {
        return current + url.slice(production.length);
      }
    }
    return url;
  };

  const visit = (node: MarkdownNode): void => {
    if (node.type === "link" && node.url) node.url = rewrite(node.url);
    node.children?.forEach(visit);
  };

  return visit;
}
